export const AiLogoSvg = () => (
  <svg
    width="39"
    height="32"
    viewBox="0 0 39 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12185_47242)">
      <rect width="38.4" height="32" fill="white" />
      <path
        d="M24.6864 27.4286C24.6864 23.6052 26.0162 20.3636 28.676 17.7039C31.3357 15.0442 34.5773 13.7143 38.4007 13.7143C34.5773 13.7143 31.3357 12.3844 28.676 9.72468C26.0162 7.06494 24.6864 3.82338 24.6864 0C24.6864 3.82338 23.3565 7.06494 20.6968 9.72468C18.037 12.3844 14.7955 13.7143 10.9721 13.7143C14.7955 13.7143 18.037 15.0442 20.6968 17.7039C23.3565 20.3636 24.6864 23.6052 24.6864 27.4286Z"
        fill="url(#paint0_radial_12185_47242)"
      />
      <path
        opacity="0.75"
        d="M6.85714 13.7143C6.85714 11.8026 7.52208 10.1818 8.85195 8.85195C10.1818 7.52208 11.8026 6.85714 13.7143 6.85714C11.8026 6.85714 10.1818 6.19221 8.85195 4.86234C7.52208 3.53247 6.85714 1.91169 6.85714 0C6.85714 1.91169 6.19221 3.53247 4.86234 4.86234C3.53247 6.19221 1.91169 6.85714 0 6.85714C1.91169 6.85714 3.53247 7.52208 4.86234 8.85195C6.19221 10.1818 6.85714 11.8026 6.85714 13.7143Z"
        fill="#6E56E6"
      />
      <path
        d="M12.3425 31.9541C12.3425 30.0424 13.0074 28.4217 14.3373 27.0918C15.6672 25.7619 17.2879 25.097 19.1996 25.097C17.2879 25.097 15.6672 24.4321 14.3373 23.1022C13.0074 21.7723 12.3425 20.1515 12.3425 18.2398C12.3425 20.1515 11.6776 21.7723 10.3477 23.1022C9.01782 24.4321 7.39704 25.097 5.48535 25.097C7.39704 25.097 9.01782 25.7619 10.3477 27.0918C11.6776 28.4217 12.3425 30.0424 12.3425 31.9541Z"
        fill="#F8B1DC"
      />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_12185_47242"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(24.6864 13.7143) rotate(90) scale(13.7143)"
      >
        <stop stopColor="#F470BD" />
        <stop offset="1" stopColor="#E60278" />
      </radialGradient>
      <clipPath id="clip0_12185_47242">
        <rect width="38.4" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
